import request from '@/utils/request'
const BASE_URL = '/PrintTemplate'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/GetList',
      method: 'post',
      data
    })
  },
  info(data) {
    return request({
      url: BASE_URL + '/GetInfo',
      method: 'post',
      data
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  changeName(data) {
    return request({
      url: BASE_URL + '/ChangeTemplateName',
      method: 'post',
      data
    })
  },
  setDefault(data) {
    return request({
      url: BASE_URL + '/ChangeIsDefault',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
}